import React from 'react';
import { Arrow } from '@/components/Hero';

const ROWS = [
  {
    slug: 'process-automation',
    code: 'AUTO',
    title: 'Process Automation',
    desc: 'We map your manual workflows and replace them with reliable, self-running systems connected to the tools your team already uses.',
    contents: ['Workflow design', 'Custom API integrations', 'ERP, CRM & helpdesk'],
  },
  {
    slug: 'it-consulting-email-security',
    code: 'SEC',
    title: 'IT Consulting & Email Security',
    desc: 'Security configuration and IT guidance, from email threat protection to infrastructure hardening.',
    contents: ['DMARC, DKIM & SPF', 'Zero-trust architecture', 'Security audits'],
  },
  {
    slug: 'microsoft-365-google-workspace',
    code: 'M365',
    title: 'M365 & Google Workspace',
    desc: 'Most teams use a fraction of what M365 or Google Workspace can do. We configure, govern, and cut costs on the rest.',
    contents: ['Entra ID & Conditional Access', 'License audits', 'SharePoint & Teams'],
  },
  {
    slug: 'marketing-automation',
    code: 'MKTG',
    title: 'Marketing Automation',
    desc: 'We automate outreach, nurture flows, and content pipelines, connected to the CRM you already use.',
    contents: ['Email campaigns', 'CRM & lead scoring', 'Performance dashboards'],
  },
];

const Services = () => (
  <section id="services" className="section section-alt" data-testid="services-section">
    <div className="wrap">
      <header className="section-head">
        <h2 className="reveal">We wire the systems you already run.</h2>
        <p className="lead reveal reveal-1">
          Four kinds of work, each scoped and priced before we start. We fix the two constraints that slow most teams: operational drag and weak IT foundations.
        </p>
      </header>

      <ul className="service-grid">
        {ROWS.map((row, i) => (
          <li key={row.slug} className={`reveal reveal-${i + 1}`}>
            <a href={`/services/${row.slug}`} className="service-label" data-testid={`service-link-${row.slug}`}>
              <h3>{row.title}</h3>
              <p>{row.desc}</p>
              <div className="service-contents">
                <dl>
                  <dt>Includes</dt>
                  <dd>{row.contents.join(' · ')}</dd>
                </dl>
                <div className="service-contents-side">
                  <span className="tag tag-gold">{row.code}</span>
                  <span className="service-more">
                    Details
                    <Arrow />
                  </span>
                </div>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default Services;
